import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {ORDER_USERS, PermissionAssignment, PermissionSubjectType, User} from 'smag-commons/dto/api';
import {PermissionsService} from '../../../shared/permissions.service';
import {UserFilter} from 'auth-commons';

const SELECTED_USER_COLOR = 'lightblue';
export const DEFAULT_ORDER = ORDER_USERS.CREATION_DATE_DESC;

@Component({
    selector: 'app-users-permission-assignments',
    templateUrl: './users-permission-assignments.component.html',
    styleUrls: ['./users-permission-assignments.component.scss']
})
export class UsersPermissionAssignmentsComponent implements OnInit, OnDestroy {

    private destroyed = new Subject<void>();
    private returnUrl: string;

    userFilter: UserFilter;
    user: User;
    assignments: PermissionAssignment[];

    // exported in HTML
    SELECTED_USER_COLOR = SELECTED_USER_COLOR;

    constructor(private readonly permissionsService: PermissionsService,
                private readonly router: Router,
                private readonly route: ActivatedRoute) {
        this.returnUrl = null;
        this.route.queryParams.pipe(
            takeUntil(this.destroyed)
        ).subscribe(params => {
            if (params.returnUrl) {
                this.returnUrl = params.returnUrl;
            }
            // clear "returnUrl" param
            this.router.navigate([], {
                relativeTo: this.route,
                replaceUrl: true,
                queryParams: {returnUrl: undefined},
                queryParamsHandling: 'merge'
            });
        });
        this.userFilter = {
            username: null,
            firstName: null,
            lastName: null,
            enabled: null,
            missingChecks: [],
            missingChecksOr: [],
            enabled2FA: null,
            mandatory2FA: null,
            passwordValid: null,
            orderBy: [DEFAULT_ORDER]
        };
        this.user = null;
        this.assignments = null;
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }

    onClickGotoPermissionMgmt() {
        this.router.navigate(this.returnUrl ? [this.returnUrl] : ['/c', 'permissions'], {
            queryParamsHandling: 'merge'
        });
    }

    onSelectUser(user: User) {
        this.user = user;
        this.loadUserAssignments();
    }

    private loadUserAssignments() {
        this.assignments = null; // trigger loading spinner
        this.permissionsService.getPermissionsForSubject(PermissionSubjectType.USER, this.user.u3id).subscribe(assignments => {
            this.assignments = assignments;
        });
    }
}
